export default {
  verificarCifButton: {
    marginTop: "10px",
  },
};
